import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const memberApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

memberApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('member_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

memberApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isAuthRequest = /\/member-portal\/(login|register)/.test(url);
    const path = window.location.pathname;
    const onAuthPage = path === '/login' || path === '/reset-password' || path === '/kayit';
    if (error.response?.status === 401 && !isAuthRequest && !onAuthPage) {
      localStorage.removeItem('member_token');
      localStorage.removeItem('member_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default memberApi;
